import smartStorage from "./smart-storage";

/**
 * Generates a unique identifier using the `createObjectURL` method of the `URL` interface
 * and returning the last 36 characters of the resulting string.
 *
 * @return {string} The generated unique identifier.
 */
export const generateUniqueId = () => {
  return URL.createObjectURL ? URL.createObjectURL(new Blob()).slice(-36) : "";
};

/**
 * function to detect the OS platform of the user based on the user agent string.
 * @returns windows, mac or null based on the detected platform. If the platform cannot be determined, it returns null.
 */
export const getOSPlatform = () => {
  const ua = navigator.userAgent;
  if (/windows/i.test(ua)) return "windows";
  if (/mac/i.test(ua)) return "mac";
  return null;
};

export const getDeviceId = (() => {
  let id = smartStorage.getItem("deviceId");

  if (!id) {
    id = generateUniqueId();
    smartStorage.setItem("deviceId", id);
  }
  return () => id;
})();
